export const uniqVal = ['ID', 'baseForDiff', 'valueForDiff', 'top2toDiff'];

export const RequiredRoles1 = ['baseForDiff', 'valueForDiff', 'deltaAbsolute'];

export const RequiredRoles2Query1 = [
    //'ID',
    'baseForDiff',
    'deltaAbsolute'
];

export const RequiredRoles2Query2 = [
    //'ID',
    'valueForDiff'
];

export const RequiredRoles3 = ['top2toDiff', 'valueForDiff'];

export const Preset0Roles = {
    ID: 'CardID',
    baseForDiff: 'BaseValue',
    valueForDiff: 'Value',
    deltaPercent: 'DeltaPCT',
    deltaAbsolute: 'Delta',
    deltaIcon: 'DeltaIcon',
    deltaColor: 'DeltaColor',
    title: 'Title',
    subtitle: 'Subtitle'
};

export const Preset1Roles = {
    baseForDiff: 'BaseValue',
    valueForDiff: 'Value',
    deltaPercent: 'DeltaPCT',
    deltaAbsolute: 'Delta',
    deltaIcon: 'DeltaIcon',
    deltaColor: 'DeltaColor',
    title: 'Title',
    subtitle: 'Subtitle'
};

export const Preset2RolesQuery1 = {
    ID: 'CardID',
    baseForDiff: 'BaseValue',
    deltaPercent: 'DeltaPCT',
    deltaAbsolute: 'Delta',
    deltaIcon: 'DeltaIcon',
    deltaColor: 'DeltaColor',
    title: 'Title',
    subtitle: 'Subtitle'
};

export const Preset2RolesQuery2 = {
    ID: 'CardID',
    valueForDiff: 'Value',
    title: 'Title',
    subtitle: 'Subtitle'
};

export const Preset3Roles = {
    top2toDiff: 'Top2Group',
    valueForDiff: 'Top2Values',
    deltaPercent: 'DeltaPCT',
    deltaAbsolute: 'Delta',
    deltaIcon: 'DeltaIcon',
    deltaColor: 'DeltaColor',
    title: 'Title',
    subtitle: 'Subtitle'
};

export const Role_TemplateID = [
    {},
    {
        query1: {
            baseForDiff: 'BaseValue',
            valueForDiff: 'Value',
            deltaPercent: 'DeltaPCT',
            deltaAbsolute: 'Delta',
            deltaIcon: 'DeltaIcon',
            deltaColor: 'DeltaColor',
            title: 'Title',
            subtitle: 'Subtitle'
        }
    },
    {
        query1: {
            ID: 'CardID',
            baseForDiff: 'BaseValue',
            deltaPercent: 'DeltaPCT',
            deltaAbsolute: 'Delta',
            deltaIcon: 'DeltaIcon',
            deltaColor: 'DeltaColor',
            title: 'Title',
            subtitle: 'Subtitle'
        },
        query2: {
            ID: 'CardID',
            valueForDiff: 'Value',
            title: 'Title',
            subtitle: 'Subtitle',
            display: 'Display'
        }
    },
    {
        query1: {
            top2toDiff: '(Base)ValueLabel',
            valueForDiff: '(Base)Value',
            deltaPercent: 'DeltaPCT',
            deltaAbsolute: 'Delta',
            deltaIcon: 'DeltaIcon',
            deltaColor: 'DeltaColor',
            title: 'Title',
            subtitle: 'Subtitle'
        }
    }
];
